const userDefault = {
	user: false,
	token: false,
};

export default userDefault;
